import { useViewport } from 'hooks/useViewPort';
import React, { ReactNode } from 'react';

export const ViewportContext = React.createContext<{ vw: number; vh: number } | undefined>(undefined);

export const ViewportProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const { vh, vw } = useViewport();
  return <ViewportContext.Provider value={{ vw, vh }}>{children}</ViewportContext.Provider>;
};
